import { render, staticRenderFns } from "./sendPackage.vue?vue&type=template&id=66d09ac4&scoped=true&"
import script from "./sendPackage.vue?vue&type=script&lang=js&"
export * from "./sendPackage.vue?vue&type=script&lang=js&"
import style0 from "./sendPackage.vue?vue&type=style&index=0&id=66d09ac4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d09ac4",
  null
  
)

export default component.exports